import { useRef, useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useDropdown } from '../../hooks/useDropdown';

import { SignedInDropdown } from "./SignedInDropdown"
import { getCookie, setCookie } from '../../utils';

import "./index.css";
import logoSrc from "../../images/Profile-Default.png"

function Navbar() {
  const ref = useRef();
  const navigate = useNavigate();
  const [loggedIn, setLoggedIn] = useState(getCookie("jwtToken").length > 0);
  const [showDropdown, setShowDropdown] = useDropdown(ref);
  
  useEffect(() => {
    if (!loggedIn) {
      navigate("/")
      setCookie("jwtToken", "")
    }
  }, [loggedIn])

  return (
    <div className="TractusNavbar">
      <div className="TractusNavbarLogoContainer">
        <div className="TractusNavbarLogo" />
      </div>
      <div style={{ position: "relative" }}>
        <div
          style={{ display: "flex", flexDirection: "row", alignItems: "center", cursor: "pointer" }}
          onClick={() => setShowDropdown(!showDropdown)}
        >
          <div
            className="TractusNavbarProfileImg"
            style={{ backgroundImage: `url("${logoSrc}")` }}
          />
          <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.29294 0.333374C9.71219 0.333374 9.94528 0.81834 9.68337 1.14572L5.39035 6.512C5.19019 6.7622 4.80965 6.7622 4.60948 6.512L0.316463 1.14572C0.0545568 0.818339 0.287644 0.333374 0.706898 0.333374L9.29294 0.333374Z" fill="#131313"/>
          </svg>
        </div>
        

        {showDropdown &&
          <div ref={ref}>
            <SignedInDropdown />
          </div>
        }
      </div>
    </div>
  )
}

export default Navbar
